module.exports = __webpack_public_path__ + "static/media/calender_sm.e7491e62.svg";